import { useState, useCallback } from 'react';
import { supabase } from '../lib/supabase';

/**
 * Web implementation of Apple Sign-In using Supabase OAuth redirect flow
 */
export function useAppleSignIn(onSuccess?: () => void) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const signIn = useCallback(async (): Promise<{ success: boolean; cancelled: boolean }> => {
    try {
      setLoading(true);
      setError(null);

      // Use Supabase OAuth redirect flow for web
      const { data, error: oauthError } = await supabase.auth.signInWithOAuth({
        provider: 'apple',
        options: {
          redirectTo: `${window.location.origin}/`,
        },
      });

      if (oauthError) {
        throw oauthError;
      }

      // OAuth redirect will happen, so this code may not execute
      // The success callback will be handled by the auth state change listener
      return { success: true, cancelled: false };
    } catch (err: any) {
      console.error('Apple Sign-In error (web):', err);
      const errorMessage = err.message || err.toString() || '';
      
      const isCancelled = errorMessage.includes('cancelled') || 
                        errorMessage.includes('canceled') ||
                        errorMessage.includes('popup_closed_by_user');
      
      if (isCancelled) {
        setError(null);
        return { success: false, cancelled: true };
      }
      
      setError(errorMessage || 'Apple Sign-In failed');
      return { success: false, cancelled: false };
    } finally {
      setLoading(false);
    }
  }, []);

  return { signIn, loading, error };
}

